import React, { Component } from 'react'
import { Route, Switch } from 'react-router'
import MainRouter from './components/Routers/MainRouter'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import './App.css'

class App extends Component {
  render () {
    return (
      <Switch>
        <Route path='/' component={MainRouter} />
      </Switch>
    )
  }
}

export default App
